import React from 'react';
import './Stats.css';

const DATA = [
  { val: '40+',   label: 'Verified Brands Stocked' },
  { val: '12K+',  label: 'Orders Shipped Nationwide' },
  { val: '100%',  label: 'Customer Satisfaction' },
];
export default function Stats() {
  return (
    <section className="stats-row">
      {DATA.map(({ val, label }, i) => (
        <div key={label} className={i > 0 ? 'stats-item stats-item--border' : 'stats-item'}>
          <strong className="stats-val">{val}</strong>
          <span className="stats-lbl">{label}</span>
        </div>
      ))}
    </section>
  );
}